import en from './patternsStrings.en';

export default {
  en,
};
